<template>
  <div class="uppercase text-white font-medium" :class="hideOnMobile ? 'hidden sm_block' : ''">
    <p class="mb-1" :class="poweredByClasses">Powered By</p>
    <VrifyLogoSnug alt="VRIFY" draggable="false" :class="logoClasses" />
  </div>
</template>

<script lang="ts" setup>
import VrifyLogoSnug from '@/assets/images/vrify-logo-snug.svg'
const props = defineProps({
  hideOnMobile: {
    type: Boolean,
    default: false,
  },
  largerLogoBreakpoint: {
    type: String as PropType<'sm' | 'md' | 'lg' | 'xl'>,
    default: 'sm',
  },
})

const poweredByClasses = computed(() => {
  switch (props.largerLogoBreakpoint) {
    case 'sm':
      return 'text-xs sm_text-sm'
    case 'md':
      return 'text-xs md_text-sm'
    case 'lg':
      return 'text-xs lg_text-sm'
    case 'xl':
      return 'text-xs xl_text-sm'
    default:
      return 'text-xs sm_text-sm'
  }
})
const logoClasses = computed(() => {
  switch (props.largerLogoBreakpoint) {
    case 'sm':
      return 'h-4 sm_h-6'
    case 'md':
      return 'h-4 md_h-6'
    case 'lg':
      return 'h-4 lg_h-6'
    case 'xl':
      return 'h-4 xl_h-6'
    default:
      return 'h-4 sm_h-6'
  }
})
</script>
